import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroRiepilogativoIvaModalComponent } from './worker-registro-riepilogativo-iva-modal';

export const WorkerRegistroRiepilogativoIvaModalModule: string = ng
    .module('worker-registro-riepilogativo_iva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroRiepilogativoIvaModalComponent', WorkerRegistroRiepilogativoIvaModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-riepilogativo-iva-modal/worker-registro-riepilogativo-iva-modal.module.ts